import OrderPageBottom from "./OrderPageBottom";

export default OrderPageBottom;
